import { render, staticRenderFns } from "./VPopover.vue?vue&type=template&id=b2eea3ac"
import script from "./VPopover.vue?vue&type=script&lang=js"
export * from "./VPopover.vue?vue&type=script&lang=js"
import style0 from "./VPopover.vue?vue&type=style&index=0&id=b2eea3ac&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2eea3ac')) {
      api.createRecord('b2eea3ac', component.options)
    } else {
      api.reload('b2eea3ac', component.options)
    }
    module.hot.accept("./VPopover.vue?vue&type=template&id=b2eea3ac", function () {
      api.rerender('b2eea3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VPopover.vue"
export default component.exports